module.exports = __webpack_public_path__ + "fonts/Muli-Bold.1c7adc24.woff";